module.exports = "<p>\n  contractor-list works!\n</p>\n"